/* eslint-disable */
export default {
  GET_CONSENT: 0,
  SELECT_ACCOUNTS: 1,
  VERIFY_PAYMENT_NETWORKS: 2,
  SETUP_PAYMENTS: 3
};

